import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import "./Avantages.css";

const Avantages = () => {
  const avantages = [
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10"/>
          <polyline points="12,6 12,12 16,14"/>
        </svg>
      ),
      title: "Gain de temps",
      description: "Automatisez vos tâches répétitives : réservations, commandes, relances clients. Libérez jusqu'à 15h par semaine.",
      stats: "15h/semaine",
      details: [
        "Réservations automatiques 24h/24",
        "Confirmations et rappels par SMS/email",
        "Synchronisation avec votre agenda",
        "Gestion des annulations sans intervention"
      ]
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
        </svg>
      ),
      title: "Économies",
      description: "Réduisez vos coûts opérationnels. Plus besoin de personnel dédié aux appels et à la gestion manuelle.",
      stats: "-30% coûts",
      details: [
        "Moins de personnel administratif nécessaire",
        "Réduction des erreurs de saisie",
        "Optimisation des stocks et achats",
        "Facturation automatique"
      ]
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
      ),
      title: "Plus de clients",
      description: "Soyez visible en ligne. Vos clients vous trouvent sur Google et réservent en quelques clics.",
      stats: "+40% clients",
      details: [
        "Référencement local optimisé",
        "Présence Google Maps",
        "Réservation en ligne 24h/24",
        "Avis clients visibles"
      ]
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="23,6 13.5,15.5 8.5,10.5 1,18"/>
          <polyline points="17,6 23,6 23,12"/>
        </svg>
      ),
      title: "Croissance",
      description: "Développez votre activité sans multiplier les ressources. Scalez intelligemment.",
      stats: "+50% CA",
      details: [
        "Capacité d'accueil augmentée",
        "Gestion multi-sites centralisée",
        "Analyses et statistiques en temps réel",
        "Décisions basées sur les données"
      ]
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
          <polyline points="9,12 11,14 15,10"/>
        </svg>
      ),
      title: "Fiabilité",
      description: "Fini les oublis, les doubles réservations, les erreurs. Votre système gère tout automatiquement.",
      stats: "0 erreur",
      details: [
        "Zéro double réservation",
        "Rappels automatiques clients",
        "Historique complet conservé",
        "Sauvegarde quotidienne des données"
      ]
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
          <line x1="8" y1="21" x2="16" y2="21"/>
          <line x1="12" y1="17" x2="12" y2="21"/>
        </svg>
      ),
      title: "Image pro",
      description: "Offrez une expérience digitale moderne à vos clients. Démarquez-vous de la concurrence.",
      stats: "5 étoiles",
      details: [
        "Site web à votre image",
        "Application intuitive",
        "Parcours client fluide",
        "Communication professionnelle"
      ]
    }
  ];

  const temoignages = [
    {
      text: "Depuis que j'ai mon application de réservation, je ne réponds plus au téléphone pendant les coupes. Mes clients adorent réserver en ligne.",
      author: "Sophie M.",
      business: "Salon de coiffure, Paris 11e",
      result: "+35% de réservations"
    },
    {
      text: "L'automatisation de mes commandes m'a fait gagner un temps fou. Je me concentre enfin sur mon métier.",
      author: "Marc D.",
      business: "Restaurant, Boulogne",
      result: "10h gagnées/semaine"
    },
    {
      text: "Mon site apparaît en première page Google. Les nouveaux clients arrivent naturellement.",
      author: "Julie R.",
      business: "Institut de beauté, Versailles",
      result: "Position 1 sur Google"
    }
  ];

  return (
    <div className="avantages-page">
      <Helmet>
        <title>Avantages | Digitalisation Commerce | E-Shops SEO</title>
        <meta name="description" content="Découvrez les avantages de digitaliser votre commerce : gain de temps, économies, plus de clients. Solutions sur mesure pour PME." />
      </Helmet>

      <section className="avantages-hero">
        <div className="container">
          <h1>Pourquoi digitaliser votre commerce ?</h1>
          <p className="hero-subtitle">
            Automatisez, optimisez, développez. Découvrez comment nos solutions 
            transforment les commerces de proximité.
          </p>
        </div>
      </section>

      <section className="avantages-grid-section">
        <div className="container">
          <div className="avantages-grid">
            {avantages.map((avantage, index) => (
              <div key={index} className="avantage-card">
                <div className="avantage-icon">{avantage.icon}</div>
                <div className="avantage-stats">{avantage.stats}</div>
                <h3>{avantage.title}</h3>
                <p>{avantage.description}</p>
                <ul className="avantage-details">
                  {avantage.details.map((detail, i) => (
                    <li key={i}>{detail}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="comparaison-section">
        <div className="container">
          <h2>Avant / Après digitalisation</h2>
          <div className="comparaison-table">
            <div className="comparaison-col avant">
              <h3>Sans solution digitale</h3>
              <ul>
                <li>Appels téléphoniques constants</li>
                <li>Agenda papier ou Excel</li>
                <li>Oublis et doubles réservations</li>
                <li>Clients perdus hors horaires</li>
                <li>Pas de visibilité en ligne</li>
                <li>Gestion manuelle chronophage</li>
              </ul>
            </div>
            <div className="comparaison-col apres">
              <h3>Avec E-Shops SEO</h3>
              <ul>
                <li>Réservations automatiques 24/7</li>
                <li>Planning digital synchronisé</li>
                <li>Zéro conflit de réservation</li>
                <li>Clients servis à toute heure</li>
                <li>Première page Google</li>
                <li>Automatisation complète</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="temoignages-section">
        <div className="container">
          <h2>Ils ont franchi le pas</h2>
          <div className="temoignages-grid">
            {temoignages.map((temoignage, index) => (
              <div key={index} className="temoignage-card">
                <p className="temoignage-text">"{temoignage.text}"</p>
                <div className="temoignage-author">
                  <strong>{temoignage.author}</strong>
                  <span>{temoignage.business}</span>
                </div>
                <div className="temoignage-result">{temoignage.result}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <h2>Prêt à transformer votre commerce ?</h2>
          <p>Discutons de votre projet. Premier rendez-vous gratuit et sans engagement.</p>
          <Link to="/contact" className="cta-button">Demander un devis gratuit</Link>
        </div>
      </section>
    </div>
  );
};

export default Avantages;
